import { SearchResourceDictionaryService } from '@app/core/services/resource-dictionary/search-resource-dictionary.service';
import { OverrideColumnDefinition, OverrideColumnParameters } from '@app/search/gridOptions/search-grid-options-formatter';
import { SampleSearchColumnFields, SampleSearchGridOptionsFormatter } from '@app/search/gridOptions/sample-search-grid-options-formatter';
import { BsshDatePipe } from '@app/core/utilities/pipes/bssh-date.pipe';
import { HttpClient } from '@angular/common/http';

export class SampleLaunchFormChooserGridOptionsFormatter extends SampleSearchGridOptionsFormatter {
  constructor(
      public resourceDictionaryService: SearchResourceDictionaryService,
      public bsshDatePipe: BsshDatePipe,
      public http: HttpClient
  ) {
      super(resourceDictionaryService, bsshDatePipe, http);
  }

  protected getOverrideColumnParameters(): OverrideColumnParameters<SampleSearchColumnFields> {
      const inclusiveColumns: SampleSearchColumnFields[] = [
          SampleSearchColumnFields.Name,
          SampleSearchColumnFields.Created,
          SampleSearchColumnFields.Owner,
          SampleSearchColumnFields.Project,
          SampleSearchColumnFields.Size,
          SampleSearchColumnFields.ReadLength1,
          SampleSearchColumnFields.ReadLength2,
          SampleSearchColumnFields.NumReadsPF,
          SampleSearchColumnFields.Genome
        ];

      const overrideColumnDefinitions: OverrideColumnDefinition<SampleSearchColumnFields>[] = [];

      return {
          inclusiveColumns,
          overrideColumnDefinitions
      };
  }
}

